// Session storage key for validated passcode
const VALIDATED_PASSCODE_KEY = 'privateListings/validatedPasscode';

// Helper functions for session storage
const getValidatedPasscode = () => {
  try {
    const stored = sessionStorage.getItem(VALIDATED_PASSCODE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Failed to parse validated passcode from session storage:', error);
    return {};
  }
};

const setValidatedPasscode = (listingId, passcode) => {
  try {
    const validatedPasscode = getValidatedPasscode();
    validatedPasscode[listingId] = passcode;
    sessionStorage.setItem(VALIDATED_PASSCODE_KEY, JSON.stringify(validatedPasscode));
  } catch (error) {
    console.warn('Failed to store validated passcode in session storage:', error);
  }
};

const isPasscodeValidatedInSession = (listingId) => {
  try {
    const validatedPasscode = getValidatedPasscode();
    return !!validatedPasscode[listingId];
  } catch (error) {
    console.warn('Failed to check passcode validation status:', error);
    return false;
  }
};

// Clean up all passcode (optional utility function)
const cleanupPasscode = () => {
  try {
    sessionStorage.removeItem(VALIDATED_PASSCODE_KEY);
  } catch (error) {
    console.warn('Failed to cleanup passcode:', error);
  }
};

const getValidatedPasscodeById = (listingId) => {
  const validatedPasscode = getValidatedPasscode();
  return validatedPasscode[listingId];
};

export {
  setValidatedPasscode,
  isPasscodeValidatedInSession,
  cleanupPasscode,
  getValidatedPasscodeById,
};
